import * as z from "zod";
import { threePlDateRangeInput } from "./three-pl-date-range-input";

export const leaderboardRowSchema = z.object({
  rank: z.number(),
  name: z.string(),
  totalItemsProcessed: z.number(),
  totalItemsPicked: z.number(),
});

export type LeaderboardRow = z.infer<typeof leaderboardRowSchema>;

export const get3plLeaderboard = {
  name: "get3plLeaderboard" as const,
  input: threePlDateRangeInput,
  output: z.object({ rows: z.array(leaderboardRowSchema) }),
};
